module.exports = __webpack_public_path__ + "media/images/icons/media-b41cddd23681b504c18ca726954e69c6.svg";